module.exports = __webpack_public_path__ + "media/fonts/Cormorant-MediumItalic-5c329d7ca6b9be2c92b1b75bfd88fd30.woff2";